var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c(
        "div",
        {
          staticClass: "absolute left-2.5 flex items-center h-8 search-icon",
          class: _vm.iconStyle,
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z",
                  stroke: "#717986",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M14.0001 13.9996L11.1001 11.0996",
                  stroke: "#717986",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _c("InputFilter", {
        staticClass:
          "pl-6 block w-full max-h-8 rounded-full border border-gray-400 border-opacity-50 bg-white customHeight",
        class: _vm.nameSearchStyle,
        attrs: {
          placeholder: _vm.placeholderText,
          debounceTime: _vm.debounceTime,
          iconStyle: "customIcon bg-white",
          inputClass: "customFormInput",
        },
        on: { input: _vm.search },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }